import {
    ADD_BR_SUBSCRIPTION,
    ADD_BR_SUBSCRIPTION_FAIL,
    ADD_BR_SUBSCRIPTION_SUCCESS,
    ADD_SOCIAL_TEMPLATES,
    ADD_SOCIAL_TEMPLATES_FAIL,
    ADD_SOCIAL_TEMPLATES_SUCCESS,
    FETCH_ADMIN_OKR,
    FETCH_ADMIN_OKR_FAIL,
    FETCH_ADMIN_OKR_SUCCESS,
    FETCH_MANAGE_SUB_TYPE,
    FETCH_MANAGE_SUB_TYPE_FAIL,
    FETCH_MANAGE_SUB_TYPE_SUCCESS,
    FETCH_BR_SUBSCRIPTION,
    FETCH_BR_SUBSCRIPTION_FAIL,
    FETCH_MANAGE_BR_SUBSCRIPTION,
    FETCH_MANAGE_BR_SUBSCRIPTION_FAIL,
    FETCH_MANAGE_BR_SUBSCRIPTION_SUCCESS,
    FETCH_BR_SUBSCRIPTION_SUCCESS,
    FETCH_SOCIAL_TEMPLATES,
    FETCH_SOCIAL_TEMPLATES_FAIL,
    FETCH_SOCIAL_TEMPLATES_SUCCESS,
    SEND_SOCIAL_TEMPLATE_TEST,
    SEND_SOCIAL_TEMPLATE_TEST_FAIL,
    SEND_SOCIAL_TEMPLATE_TEST_SUCCESS,
    UPDATE_BR_SUBSCRIPTION,
    UPDATE_BR_SUBSCRIPTION_FAIL,
    UPDATE_BR_SUBSCRIPTION_SUCCESS,
    UPDATE_SOCIAL_TEMPLATES,
    UPDATE_SOCIAL_TEMPLATES_FAIL,
    UPDATE_SOCIAL_TEMPLATES_SUCCESS,
    FETCH_ALL_ENTITIES,
    FETCH_ALL_ENTITIES_SUCCESS,
    FETCH_ALL_ENTITIES_FAIL,
    VERIFY_PRIMARY_DOMAIN,
    VERIFY_PRIMARY_DOMAIN_SUCCESS,
    VERIFY_PRIMARY_DOMAIN_FAIL,
    UPDATE_ENTITY_NAME,
    UPDATE_ENTITY_NAME_SUCCESS,
    UPDATE_ENTITY_NAME_FAIL,
    UPDATE_PENTEST_SETTING_FOR_ENTITY,
    UPDATE_PENTEST_SETTING_FOR_ENTITY_SUCCESS,
    UPDATE_PENTEST_SETTING_FOR_ENTITY_FAIL,
    UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY,
    UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY_SUCCESS,
    UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY_FAIL,
    UPDATE_ENTITY_SUCCESS,
    UPDATE_ENTITY_FAIL,
    UPDATE_ENTITY,
    UPDATE_ENTITY_SETTINGS, UPDATE_ENTITY_SETTINGS_SUCCESS, UPDATE_ENTITY_SETTINGS_FAIL
} from "../constants/ActionTypes";


/*  sarahp**********14.APR.22*****
 *  FETCH OKR INFO
     **********************  */
export const fetchAdminOKR = ()=>{
    return{
        type: FETCH_ADMIN_OKR
    }
}

export const fetchAdminOKRSuccess = (data)=>{
    return{
        type: FETCH_ADMIN_OKR_SUCCESS,
        payload: data
    }
}

export const fetchAdminOKRFail = (data)=>{
    return{
        type: FETCH_ADMIN_OKR_FAIL,
        payload: data
    }
}

/*  sarahp**********04.MAY.22*****
 *  FETCH SOCIAL TEMPLATES OBJECT
     **********************  */

export const fetchSocialTemplates = ()=>{
    return{
        type: FETCH_SOCIAL_TEMPLATES
    }
}

export const fetchSocialTemplatesSuccess = (data)=>{
    return{
        type: FETCH_SOCIAL_TEMPLATES_SUCCESS,
        payload: data
    }
}

export const fetchSocialTemplatesFail = (data)=>{
    return{
        type: FETCH_SOCIAL_TEMPLATES_FAIL,
        payload: data
    }
}

/*  sarahp**********05.MAY.22*****
 *  Add a SOCIAL TEMPLATES OBJECT
     **********************  */
/**
 * Summary. addSocialTemplate
 *
 * Description. Dispatch this to create a new social phishing template
 *
 * @param {number}   socialAccountId    (required)id for the social account to be associated with the phishing template, found social templates obj
 * @param {string}   subjectString      (required)email subject for the template
 * @param {string}  htmlMessage         (required)html message for the template, stored as a string
 * @param {string}  plainTextMessage    (required) plaintext message-- each template needs both html & plaintext
 * @param {number}  statusId            (required) dictates the templates' use status (archives, in use, draft, testing) -- found in social templates object,
 * @param {number}  socialThemeId       (required) relates to type of phishing attempt (receipt, resume, account, etc) found in templates object
 * @param {number}  payloadTypeId       (required) 0 or 1 ONLY-- 0 denotes link type pyalod (in message); 1 is for downloads
 * @param {string}  payloadTemplate     (optional) if payloadTypeId === 1, this will be the associated download from social templates object
 * @param {string}  senderName          (optional) Displayable name for sender, not foudn in social templates object
 * @param {number}  technologyTypeId    (optional) if the templates is associated with a kind of tech, found in the social templates object
 * @param {number}  hostingProviderId   (optional) if the template is associated with a host provider, found in social templates object
 * @param {number}  vectorTypeId        (optional) if the template is associated with a kind of vector type, found in social templates object
 * @param {string}  entityToSendTo      (optional) if the template is associated with only one particular entity
 *
 * @return
 *
 * @example
 */
export const addSocialTemplates = (socialAccountId,
                                   subjectString,
                                   htmlMessage,
                                   plainTextMessage,
                                   statusId,
                                   socialThemeId,
                                   payloadTypeId,
                                   payloadTemplate=null,
                                   senderName=null,
                                   technologyTypeId=null,
                                   hostingProviderId= null,
                                   vectorTypeId= null,
                                   entityToSendTo= null,
                                   )=>{

    const payload = {
        socialAccountId,
        subjectString,
        htmlMessage,
        plainTextMessage,
        statusId,
        socialThemeId,
        payloadTypeId,
        payloadTemplate,
        senderName,
        technologyTypeId,
        hostingProviderId,
        vectorTypeId,
        entityToSendTo,
    }

    console.log("creating a phishing template with this payload", payload)

    return{
        type: ADD_SOCIAL_TEMPLATES,
        payload,
    };
};

export const addSocialTemplatesSuccess = (data)=>{
    return{
        type: ADD_SOCIAL_TEMPLATES_SUCCESS,
        payload: data
    }
}

export const addSocialTemplatesFail = (data)=>{
    return{
        type: ADD_SOCIAL_TEMPLATES_FAIL,
        payload: data
    }
}

/*  sarahp**********05.MAY.22*****
 *  UPDATE a SOCIAL TEMPLATES OBJECT
     **********************  */
/**
 *  Summary. updateSocialTemplate
 *
 *
 * @param {number}  tempalteId          (required) the id of the template to be updated
 * @param {number}   socialAccountId    id for the social account to be associated with the phishing template, found social templates obj
 * @param {string}   subjectString      email subject for the template
 * @param {string}  htmlMessage         html message for the template, stored as a string
 * @param {string}  plainTextMessage     plaintext message-- each template needs both html & plaintext
 * @param {number}  statusId             dictates the templates' use status (archives, in use, draft, testing) -- found in social templates object,
 * @param {number}  socialThemeId        relates to type of phishing attempt (receipt, resume, account, etc) found in templates object
 * @param {number}  payloadTypeId        0 or 1 ONLY-- 0 denotes link type pyalod (in message); 1 is for downloads
 * @param {string}  payloadTemplate      if payloadTypeId === 1, this will be the associated download from social templates object
 * @param {string}  senderName           Displayable name for sender, not foudn in social templates object
 * @param {number}  technologyTypeId     if the templates is associated with a kind of tech, found in the social templates object
 * @param {number}  hostingProviderId    if the template is associated with a host provider, found in social templates object
 * @param {number}  vectorTypeId         if the template is associated with a kind of vector type, found in social templates object
 * @param {string}  entityToSendTo       if the template is associated with only one particular entity
 *
 *
 */
export const updateSocialTemplates = (templateId,
                                      {
                                          socialAccountId = null,
                                          subjectString = null,
                                          htmlMessage = null,
                                          plainTextMessage = null,
                                          statusId = null,
                                          socialThemeId = null,
                                          payloadTypeId = null,
                                          payloadTemplate = null,
                                          senderName = null,
                                          technologyTypeId = null,
                                          hostingProviderId = null,
                                          vectorTypeId = null,
                                          entityToSendTo = null,
                                      })=>{
    return{
        type: UPDATE_SOCIAL_TEMPLATES,
        payload: {
            templateId,
            updatesToMake: {
                social_account: socialAccountId ? socialAccountId : null,
                subject: subjectString ? subjectString : null,
                html_message: htmlMessage ? htmlMessage: null,
                plaintext_message: plainTextMessage ? plainTextMessage: null,
                status: statusId !== undefined && statusId !== null ? statusId: null,
                social_theme: socialThemeId !==undefined && socialThemeId !== null ? socialThemeId: null,
                has_payload: payloadTypeId ? payloadTypeId: null,
                payload_template: payloadTemplate ? payloadTemplate : null,
                sender_name: senderName ? senderName : null,
                associated_technology_tag: technologyTypeId ? technologyTypeId : null,
                associated_hosting_provider_tag: hostingProviderId ? hostingProviderId : null,
                associated_vector_definition: vectorTypeId ? vectorTypeId : null,
                associated_entity: entityToSendTo ? entityToSendTo : null,
            }
        }
    }
}

/**
 * Summary. updateTemplateMessage, update the htmlMessage and plainTextMessage associated with a template
 * @param {string} templateId
 * @param {string} htmlMessage
 * @param {string} plainTextMessage
 * @returns {{payload:
 *              {updatesToMake:
 *              {associated_entity: (string|null), subject: (string|null), social_theme: (number|null), has_payload: (number|null), technologyTypeId: (number|null), senderName: (string|null), associated_hosting_provider_tag: (number|null), html_message: (string|null), plaintext_message: (string|null), vectorTypeId: (number|null), social_account: (number|null), payloadTemplate: (string|number), status: (number|null)}, templateId}, type: string}}
 */

export const updateTemplateHTMLMessage = (templateId, htmlMessage)=>{
    return updateSocialTemplates(templateId,
        {
        htmlMessage: htmlMessage,
    });

}

export const updateTemplatePlainTextMessage = (templateId, plainTextMessage)=>{
    return updateSocialTemplates(templateId,
        {
            plainTextMessage: plainTextMessage,
        });

}

export const updateTemplateMessages = (templateId, htmlMessage, plainTextMessage)=>{
    return updateSocialTemplates(templateId,
        {
            htmlMessage: htmlMessage,
            plainTextMessage: plainTextMessage,
        })
}

/**
 * Summary. updateTemplateSenderName
 * @param templateId
 * @param senderName
 * @returns {{payload: {updatesToMake: {associated_entity: (string|null), subject: (string|null), social_theme: (number|null), has_payload: (number|null), technologyTypeId: (number|null), senderName: (string|null), associated_hosting_provider_tag: (number|null), html_message: (string|null), plaintext_message: (string|null), vectorTypeId: (number|null), social_account: (number|null), payloadTemplate: (string|number), status: (number|null)}, templateId}, type: string}}
 */
export const updateTemplateSenderName = (templateId, senderName) => {
    return updateSocialTemplates(templateId,
        {
            senderName: senderName,
        });

}

/**
 *
 * @param templateId
 * @param subjectString
 * @returns {{payload: {updatesToMake: {associated_entity: (string|null), subject: (string|null), social_theme: (number|null), has_payload: (number|null), technologyTypeId: (number|null), senderName: (string|null), associated_hosting_provider_tag: (number|null), html_message: (string|null), plaintext_message: (string|null), vectorTypeId: (number|null), social_account: (number|null), payloadTemplate: (string|number), status: (number|null)}, templateId}, type: string}}
 */
export const updateTemplateSubject = (templateId, subjectString) => {
    return updateSocialTemplates(templateId,
        {
            subjectString: subjectString,
        });
}

/**
 *
 * @param templateId
 * @param statusId
 * @returns {{payload: {updatesToMake: {associated_entity: (string|null), subject: (string|null), social_theme: (number|null), has_payload: (number|null), technologyTypeId: (number|null), senderName: (string|null), associated_hosting_provider_tag: (number|null), html_message: (string|null), plaintext_message: (string|null), vectorTypeId: (number|null), social_account: (number|null), payloadTemplate: (string|number), status: (number|null)}, templateId}, type: string}}
 */
export const updateTemplateStatus = (templateId, statusId) => {
    return updateSocialTemplates(templateId,
        {
            statusId: statusId,
        });
}

/**
 *
 * @param templateId
 * @param socialAccountId
 * @returns {{payload: {updatesToMake: {associated_entity: (string|null), subject: (string|null), social_theme: (number|null), payload_template: (string|number), sender_name: (string|null), has_payload: (number|null), associated_technology_tag: (number|null), associated_hosting_provider_tag: (number|null), html_message: (string|null), plaintext_message: (string|null), associated_vector_definition: (number|null), social_account: (number|null), status: (number|null)}, templateId}, type: string}}
 */
export const updateTemplateSocialAccount = (templateId, socialAccountId) => {
    return updateSocialTemplates(templateId,
        {
            socialAccountId: socialAccountId,
        });
}

/**
 *
 * @param templateId
 * @param socialThemeId
 * @returns {{payload: {updatesToMake: {associated_entity: (string|null), subject: (string|null), social_theme: (number|null), payload_template: (string|null), sender_name: (string|null), has_payload: (number|null), associated_technology_tag: (number|null), associated_hosting_provider_tag: (number|null), html_message: (string|null), plaintext_message: (string|null), associated_vector_definition: (number|null), social_account: (number|null), status: (number|null)}, templateId}, type: string}}
 */
export const updateTemplateSocialTheme = (templateId, socialThemeId) =>{
    return updateSocialTemplates(templateId,
        {
            socialThemeId: socialThemeId,
        })
}

/**
 *
 * @param templateId
 * @param statusId
 * @returns {{payload: {updatesToMake: {associated_entity: (string|null), subject: (string|null), social_theme: (number|null), payload_template: (string|null), sender_name: (string|null), has_payload: (number|null), associated_technology_tag: (number|null), associated_hosting_provider_tag: (number|null), html_message: (string|null), plaintext_message: (string|null), associated_vector_definition: (number|null), social_account: (number|null), status: (number|null)}, templateId}, type: string}}
 */
export const updateTemplateTestStatus = (templateId, statusId) => {
    return updateSocialTemplates(templateId,
        {
            statusId: statusId,
        });
}

/**
 *
 * @param templateId
 * @param vectorTypeId
 * @returns {{payload: {updatesToMake: {associated_entity: (string|null), subject: (string|null), social_theme: (number|null), payload_template: (string|null), sender_name: (string|null), has_payload: (number|null), associated_technology_tag: (number|null), associated_hosting_provider_tag: (number|null), html_message: (string|null), plaintext_message: (string|null), associated_vector_definition: (number|null), social_account: (number|null), status: (number|null)}, templateId}, type: string}}
 */
export const updateTemplateAssociatedVector = (templateId, vectorTypeId)=>{
    return updateSocialTemplates(templateId,
        {
            vectorTypeId: vectorTypeId,
        });
}

/**
 *
 * @param templateId
 * @param technologyTypeId
 * @returns {{payload: {updatesToMake: {associated_entity: (string|null), subject: (string|null), social_theme: (number|null), payload_template: (string|null), sender_name: (string|null), has_payload: (number|null), associated_technology_tag: (number|null), associated_hosting_provider_tag: (number|null), html_message: (string|null), plaintext_message: (string|null), associated_vector_definition: (number|null), social_account: (number|null), status: (number|null)}, templateId}, type: string}}
 */
export const updateTemplateAssociatedTech = (templateId, technologyTypeId)=>{
    return updateSocialTemplates(templateId,
        {
            technologyTypeId: technologyTypeId,
        });
}

/**
 *
 * @param templateId
 * @param hostingProviderId
 * @returns {{payload: {updatesToMake: {associated_entity: (string|null), subject: (string|null), social_theme: (number|null), payload_template: (string|null), sender_name: (string|null), has_payload: (number|null), associated_technology_tag: (number|null), associated_hosting_provider_tag: (number|null), html_message: (string|null), plaintext_message: (string|null), associated_vector_definition: (number|null), social_account: (number|null), status: (number|null)}, templateId}, type: string}}
 */
export const updateTemplateAssociatedHostProvider = (templateId, hostingProviderId)=>{
    return updateSocialTemplates(templateId,
        {
            hostingProviderId: hostingProviderId,
        })
}


export const updateSocialTemplatesSuccess = (data)=>{
    return{
        type: UPDATE_SOCIAL_TEMPLATES_SUCCESS,
        payload: data
    }
}

export const updateSocialTemplatesFail = (data)=>{
    return{
        type: UPDATE_SOCIAL_TEMPLATES_FAIL,
        payload: data
    }
}

/*  sarahp**********11.MAY.22*****
 *  Send A Test of the selected phishing template
     **********************  */

export const sendSocialTemplateTest = (templateId)=>{
    return{
        type: SEND_SOCIAL_TEMPLATE_TEST,
        payload: {
            templateId
        }
    };
}

export const sendSocialTemplateTestSuccess = (data)=>{
    return{
        type: SEND_SOCIAL_TEMPLATE_TEST_SUCCESS,
        payload: data
    }
}

export const sendSocialTemplateTestFail = (data)=>{
    return{
        type: SEND_SOCIAL_TEMPLATE_TEST_FAIL,
        payload: data
    }
}

/*  sarahp**********18.MAY.22*****
 *  moving add/update subscriptions (updated api call and moved to admin)
     **********************  */

/* ****************
Adding a SUBSCRIPTION
 *******************/
/**
 * Summary. addBRSubscription
 *
 * Description. Dispatch this to add a BreachRisk subscription to the given customer
 *
 * @param {number}   customerId             the customer id of the customer/client company that will be given this subscription
 * @param {number}   subscriptionType        One of the Id numbers for the subscription type (i.e. BreachRisk Portfolio = 1, BRfBusiness = 2)
 * @param {number}   subscriptionLevel        One of the Id numbers for the subscription level (i.e. BRP starter = 2)
 * @param {date}     subscriptionStart        datetime of the start of the subscription
 * @param {date}     subscriptionEnd          datetime of the end of the subscription
 *
 * @return
 *
 * @example
 */
export const addBRSubscription = (customerId, subscriptionType, subscriptionLevel, subscriptionStart, subscriptionEnd) => {
    return {
        type: ADD_BR_SUBSCRIPTION,
        payload: {
            customerId,
            subscriptionType,
            subscriptionLevel,
            subscriptionStart,
            subscriptionEnd
        }
    };
};

export const addBRSubscriptionSuccess = (data) => {
    return {
        type: ADD_BR_SUBSCRIPTION_SUCCESS,
        payload: data
    };
};

export const addBRSubscriptionFail = (data) => {
    return {
        type: ADD_BR_SUBSCRIPTION_FAIL,
        payload: data
    };
};

/* ****************
updating a SUBSCRIPTION
 *******************/
/**
 * Summary. updateBRSubscription. do not use this function, should only be called by other helper functions.
 *
 * Description. Dispatch this to update a BreachRisk subscription to the given subscription. parameters not included will not be updated.
 *
 * @param {number}   customerId             the customer/client company that owns the subscription. For use when displaying errors to screen in multi-tenet cases.
 * @param {number}   subscriptionId             the subscriptionId of the subscription for the  customer/client company that will be given this subscription
 * @param {number}   subscriptionType        One of the Id numbers for the subscription type (i.e. BreachRisk Portfolio = 1, BRfBusiness = 2)
 * @param {number}   subscriptionLevel        One of the Id numbers for the subscription level (i.e. BRP starter = 2)
 * @param {date}     subscriptionStart        datetime of the start of the subscription
 * @param {date}     subscriptionEnd          datetime of the end of the subscription
 * @param {boolean}     isActive          whether this subscription should be active or not
 *
 * @return
 *
 * @example
 */
const updateBRSubscription = (customerId,
                              subscriptionId, {
                                  subscriptionType= null,
                                  subscriptionLevel= null,
                                  subscriptionStart= null,
                                  subscriptionEnd= null,
                                  isActive = null
                              }) => {
    return {
        type: UPDATE_BR_SUBSCRIPTION,
        payload: {
            customerId,
            subscriptionId,
            updatesToMake: {
                subscription_type: subscriptionType,
                subscription_level: subscriptionLevel,
                subscription_start: subscriptionStart,
                subscription_end: subscriptionEnd,
                is_active: isActive
            }
        }
    };
};

/**
 * Summary. updateBRSubscriptionEndDate.
 *
 * Description. Dispatch this to modify the dates of the given subscription.
 *
 * @param {number}   customerId             the customer/client company that owns the subscription. For use when displaying errors to screen in multi-tenet cases.
 * @param {number}   subscriptionId             the subscriptionId of the subscription for the  customer/client company that will be given this subscription
 * @param {date}     subscriptionEnd          datetime of the end of the subscription
 *
 * @return
 *
 * @example
 */
export const updateBRSubscriptionEndDate = (customerId, subscriptionId, subscriptionEnd) => {
    return updateBRSubscription(customerId, subscriptionId, {subscriptionEnd: subscriptionEnd})
};

/**
 * Summary. updateBRSubscriptionStartDate.
 *
 * Description. Dispatch this to modify the dates of the given subscription.
 *
 * @param {number}   customerId             the customer/client company that owns the subscription. For use when displaying errors to screen in multi-tenet cases.
 * @param {number}   subscriptionId             the subscriptionId of the subscription for the  customer/client company that will be given this subscription
 * @param {date}     subscriptionStart          datetime of the start of the subscription
 *
 * @return
 *
 * @example
 */
export const updateBRSubscriptionStartDate = (customerId, subscriptionId, subscriptionStart) => {
    return updateBRSubscription(customerId, subscriptionId, {subscriptionStart: subscriptionStart})
};

/**
 * Summary. updateBRSubscriptionDates.
 *
 * Description. Dispatch this to modify the dates of the given subscription.
 *
 * @param {number}   customerId             the customer/client company that owns the subscription. For use when displaying errors to screen in multi-tenet cases.
 * @param {number}   subscriptionId             the subscriptionId of the subscription for the  customer/client company that will be given this subscription
 *  @param {date}     subscriptionStart          datetime of the start of the subscription
 * @param {date}     subscriptionEnd          datetime of the end of the subscription
 *
 * @return
 *
 * @example
 */
export const updateBRSubscriptionDates = (customerId, subscriptionId, subscriptionStart, subscriptionEnd) => {
    return updateBRSubscription(customerId, subscriptionId, {subscriptionStart: subscriptionStart, subscriptionEnd: subscriptionEnd})
};

/**
 * Summary. updateBRSubscriptionDeactivate.
 *
 * Description. Dispatch this to disable the given subscription.
 *
 * @param {number}   customerId             the customer/client company that owns the subscription. For use when displaying errors to screen in multi-tenet cases.
 * @param {number}   subscriptionId             the subscriptionId of the subscription for the  customer/client company that will be given this subscription
 *
 * @return
 *
 * @example
 */
export const updateBRSubscriptionDeactivate = (customerId, subscriptionId) => {
    return updateBRSubscription(customerId, subscriptionId, {isActive: false})
};

/**
 * Summary. activateBRSubscription.
 *
 * Description. Dispatch this to enable the given subscription.
 *
 * @param {number}   customerId             the customer/client company that owns the subscription. For use when displaying errors to screen in multi-tenet cases.
 * @param {number}   subscriptionId             the subscriptionId of the subscription for the  customer/client company that will be given this subscription
 *
 * @return
 *
 * @example
 */
export const updateBRSubscriptionActivate = (customerId, subscriptionId) => {
    return updateBRSubscription(customerId, subscriptionId, {isActive: true})
};

/**
 * Summary. activateBRSubscription.
 *
 * Description. Dispatch this to update the given subscription level
 *
 * @param {number}   customerId             the customer/client company that owns the subscription. For use when displaying errors to screen in multi-tenet cases.
 * @param {number}   subscriptionId             the subscriptionId of the subscription for the  customer/client company that will be given this subscription
 * @param {number}   newLevel             number of the new level. Must be a valid level for the given type of subscription.
 *
 * @return
 *
 * @example
 */
export const updateBRSubscriptionLevel = (customerId, subscriptionId, newLevel) => {
    //TODO: add some error checking of the level before sending the request?
    return updateBRSubscription(customerId, subscriptionId, {subscriptionLevel: newLevel})
};

/**
 * Summary. updateBRSubscriptionType.
 *
 * Description. Dispatch this to update the type of subscription
 *
 * @param {number}   customerId             the customer/client company that owns the subscription. For use when displaying errors to screen in multi-tenet cases.
 * @param {number}   subscriptionId             the subscriptionId of the subscription for the  customer/client company that will be given this subscription
 * @param {number}   newType            number of the new type. Must be a valid level for the given type of subscription.
 *
 * @return
 *
 * @example
 */
export const updateBRSubscriptionType = (customerId, subscriptionId, newType) => {
    //TODO: add some error checking of the level before sending the request?
    return updateBRSubscription(customerId, subscriptionId, {subscriptionType: newType})
};

export const updateBRSubscriptionSuccess = (data) => {
    return {
        type: UPDATE_BR_SUBSCRIPTION_SUCCESS,
        payload: data
    };
};

export const updateBRSubscriptionFail = (data) => {
    return {
        type: UPDATE_BR_SUBSCRIPTION_FAIL,
        payload: data
    };
};

/*  sarahp**********18.MAY.22*****
 *  fetching self manage subscription redirect from api
     **********************  */

export const fetchManageSubscription = (data)=>{
    return{
        type: FETCH_MANAGE_BR_SUBSCRIPTION,
        payload: data
    };
};

export const fetchManageSubscriptionSuccess = (data)=>{
    return{
        type: FETCH_MANAGE_BR_SUBSCRIPTION_SUCCESS,
        payload: data
    };
};

export const fetchManageSubscriptionFail = (data)=>{
    return{
        type: FETCH_MANAGE_BR_SUBSCRIPTION_FAIL,
        payload: data
    };
};


/*  sarahp**********04.JULY.22*****
 *  fetching self manage subscription redirect from api, sending sub type to update to
     **********************  */

export const fetchManageSubType = (data)=>{
    return{
        type: FETCH_MANAGE_SUB_TYPE,
        payload: data
    };
};

export const fetchManageSubTypeSuccess = (data)=>{
    return{
        type: FETCH_MANAGE_SUB_TYPE_SUCCESS,
        payload: data
    };
};

export const fetchManageSubTypeFail = (data)=>{
    return{
        type: FETCH_MANAGE_SUB_TYPE_FAIL,
        payload: data
    };
};


/*  sarahp**********18.MAY.22*****
 *  fetching subscription information for a customerId
     **********************  */

export const fetchSubscription = (data)=>{
    return{
        type: FETCH_BR_SUBSCRIPTION,
        payload: data
    };
};

export const fetchSubscriptionSuccess = (data)=>{
    return{
        type: FETCH_BR_SUBSCRIPTION_SUCCESS,
        payload: data
    };
};

export const fetchSubscriptionFail = (data)=>{
    return{
        type: FETCH_BR_SUBSCRIPTION_FAIL,
        payload: data
    };
};

/*  sarahp**********02.AUG.2023*****
 *  fetching subscription information for a customerId
     **********************  */

export const fetchAllEntities = (pageNumber)=>{
    return{
        type: FETCH_ALL_ENTITIES,
        payload: {
            pageNumber
        }
    };
};

export const fetchAllEntitiesSuccess = (data)=>{
    return{
        type: FETCH_ALL_ENTITIES_SUCCESS,
        payload: data
    };
};

export const fetchAllEntitiesFail = (data)=>{
    return{
        type: FETCH_ALL_ENTITIES_FAIL,
        payload: data
    };
};


/*  sarahp**********08.SEP.2023*****
 *  updating domain verifcation for an entity
     **********************  */

/**
 *
 * @param entityId
 * @param domainId
 * @returns {{payload: {customerId, entityId, domainId}, type: string}}
 */
export const verifyPrimaryDomain = (entityId, domainId) => {
    // console.log("This should be the action for verifyPrimar Domain")
    return{
        type: VERIFY_PRIMARY_DOMAIN,
        payload: {
            entityId,
            domainId,
            newStatus: true
        },
    };
};

export const unverifyPrimaryDomain = (entityId, domainId) => {
    // console.log("This should be the action for unverifyPrimary Domain")
    return{
        type: VERIFY_PRIMARY_DOMAIN,
        payload: {
            entityId,
            domainId,
            newStatus: false
        },
    };
};

export const verifyPrimaryDomainSuccess = (data) =>{
    return{
        type: VERIFY_PRIMARY_DOMAIN_SUCCESS,
        payload: data
    };
};

export const verifyPrimaryDomainFail = (data) => {
    return {
        type: VERIFY_PRIMARY_DOMAIN_FAIL,
        payload: data,
    }
};
/*  sarahp**********SEP.2023*****
 *  Make an updated api series for updating entity in entity list
     **********************  */

export const updateEntity = (
    entityId,
    property,
    updatedValue,
    // name,
    // locationCity,
    // locationState,
    // locationCountry,
    // isDemo,
    // employees,

) =>{
    console.log("This is the action that should be triggered for property", property, "to update to ", updatedValue);

    return {
        type: UPDATE_ENTITY,
        payload: {
            entityId,
            property,
            updatedValue,
            // name,
            // locationCity,
            // locationState,
            // locationCountry,
            // isDemo,
            // employees,
        }
    }
}

export const updateEntitySuccess = (data) => {
    return {
        type: UPDATE_ENTITY_SUCCESS,
        payload: data,
    };
};
export const updateEntityFail = (data) => {
    return {
        type: UPDATE_ENTITY_FAIL,
        payload: data,
    };
};

/*  sarahp**********08.SEP.2023*****
 *  updating entity name (Moved from breachrisk)
     **********************  */

export const updateEntityName = ( entityId, updatedName) => {
    return updateEntity(entityId, "name", updatedName)
};

export const updateEntityCity = ( entityId, updatedCity) => {
    return updateEntity(entityId, "location_city", updatedCity)
};

export const updateEntityState = ( entityId, updatedState) => {
    return updateEntity(entityId, "location_state", updatedState)
};

export const updateEntityCountry = ( entityId, updatedCountry) => {
    return updateEntity(entityId, "location_country", updatedCountry)
};

export const updateEntityDemoStatus = ( entityId, demoStatus) => {
    return updateEntity(entityId, "is_demo", demoStatus)
};

export const updateEntityEmployees = ( entityId, updatedEmployees) => {
    return updateEntity(entityId, "employees", updatedEmployees)
};


// export const updateEntityNameSuccess = (data) => {
//     return {
//         type: UPDATE_ENTITY_NAME_SUCCESS,
//         payload: data,
//     };
// };
// export const updateEntityNameFail = (data) => {
//     return {
//         type: UPDATE_ENTITY_NAME_FAIL,
//         payload: data,
//     };
// };

/*  sarahp**********08.SEP.2023*****
 *  updating entity's penetration testing setting "active_testing_authorized"
     **********************  */

export const activatePentestingForEntity = (entityId) =>{
    return{
        type: UPDATE_PENTEST_SETTING_FOR_ENTITY,
        payload: {
            entityId: entityId,
            newStatus: true,
        }
    }
};

export const deactivatePentestingForEntity = (entityId) =>{
    return{
        type: UPDATE_PENTEST_SETTING_FOR_ENTITY,
        payload: {
            entityId: entityId,
            newStatus: false,
        }
    }
};

export const updatePentestSettingForEntitySuccess = (data) =>{
    return{
        type: UPDATE_PENTEST_SETTING_FOR_ENTITY_SUCCESS,
        payload: data
    }
};

export const updatePentestSettingForEntityFail = (data) =>{
    return{
        type: UPDATE_PENTEST_SETTING_FOR_ENTITY_FAIL,
        payload: data
    }
}


/*  sarahp**********08.SEP.2023*****
 *  updating entity's social testing setting "social_testing_authorized"
     **********************  */

export const activateSocialTestingForEntity = (entityId) =>{
    return{
        type: UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY,
        payload: {
            entityId: entityId,
            newStatus: true,
        }
    }
};

export const deactivateSocialTestingForEntity = (entityId) =>{
    return{
        type: UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY,
        payload: {
            entityId: entityId,
            newStatus: false,
        }
    }
};

export const updateSocialTestSettingForEntitySuccess = (data) =>{
    return{
        type: UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY_SUCCESS,
        payload: data
    }
};

export const updateSocialTestSettingForEntityFail = (data) =>{
    return{
        type: UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY_FAIL,
        payload: data
    }
}

/*  sarahp**********SEP.2023*****
 *  an api series for updating entity settings in entity list
     **********************  */

export const updateEntitySettings = (
    entityId,
    property,
    updatedValue,

) =>{
    console.log("This is the action that should be triggered for property", property, "to update to ", updatedValue);

    return {
        type: UPDATE_ENTITY_SETTINGS,
        payload: {
            entityId,
            property,
            updatedValue,
        }
    }
}

export const updateEntitySettingsSuccess = (data) => {
    return {
        type: UPDATE_ENTITY_SETTINGS_SUCCESS,
        payload: data,
    };
};
export const updateEntitySettingsFail = (data) => {
    return {
        type: UPDATE_ENTITY_SETTINGS_FAIL,
        payload: data,
    };
};

// export const updateEntityLastCycleDate = (entityId, updatedValue) =>{
//     return updateEntitySettings(entityId, "last_cycle_datetime", updatedValue);
// }

export const updateEntityNextCycleDate = (entityId, updatedValue) =>{
    return updateEntitySettings(entityId, "next_cycle_datetime", updatedValue);
}

export const updateEntityOngoingCycleDate = (entityId, updatedValue) =>{
    return updateEntitySettings(entityId, "ongoing_cycle_complete_datetime", updatedValue);
}
